import { Link } from '../navigation'
import { ChartContainer } from '../cockpit/Graphs'
import type { PanelType } from '../cockpit/Graphs'
import { CostsGraph } from '../costs/CostsGraph'
import { useFxContext } from '../forecast/FxProvider'
import { useSingleTeamMangement } from '../Management'
import { useCosts } from '../costs/CostsProvider'

export function IpManagementCostsPanel({
    panelType,
    panelId,
    panelName,
}: {
    panelType: PanelType,
    panelId: number,
    panelName: string,
}) {
    const { team } = useSingleTeamMangement()
    const currency = team?.currency ?? 'EUR'
    const { fxConverter } = useFxContext()
    const { costsByEntity } = useCosts()

    const ipmCosts = costsByEntity['ip-management']?.[0] ?? []

    const byYear: Record<number, number> = {}
    ipmCosts.forEach(c => {
        const year = c.date ? new Date(c.date).getFullYear() : new Date().getFullYear()
        const native = c.amount + c.vat
        const conv = fxConverter.convert(native, c.currency || currency, currency) ?? native
        byYear[year] = Math.round((byYear[year] ?? 0) + conv)
    })

    if (Object.keys(byYear).length === 0) {
        const currentYear = new Date().getFullYear()
        for (let year = currentYear - 4; year <= currentYear; year++)
            byYear[year] = 0
    }

    return (
        <ChartContainer panelType={panelType} panelId={panelId} panelName={panelName}>
            <h2 className="pb-1">
                <Link to="/management/costs">Yearly IP Management Costs</Link>
            </h2>
            <CostsGraph {...{ byYear }} yAxisWidth={30} />
        </ChartContainer>
    )
}
